import React, { useContext } from 'react';
import { VideoContext } from '../../context/VideoContext';

const DeepDiveOpenButton = React.forwardRef(({isOpen, onClick=null, children, className, href="", fullWidth = true, span = false}, ref) => {

  const { openMenu, setOpenMenu } = useContext(VideoContext);

  const clickHandler = (e) => {    
    if (onClick) {
      e.preventDefault();
      onClick();
      setOpenMenu(false);
    }
  }

  const fullClassname = `deepDiveButton hidden absolute bottom-12 lg:bottom-8${fullWidth ? " w-full" : ""} md:w-fit min-w-[160px] mobile:mx-auto
  p-2 px-0 md:px-4 mobile:mb-3
  pointer-events-auto
  opacity-0
  shadow-button
  border-2 border-white bg-[#0e181d] rounded-full
  text-[13px] text-white font-bold text-center uppercase
  ${className}`;

  if (span) {
    return (
      <span 
        ref={ref}
        className={fullClassname}
      >
        <span className="translate-y-[1px] block">{children}</span>
      </span>
    );
  }

  const randomString = Math.random().toString(36).substring(7);
  const labelledby = `deepdive-label-${randomString}`;
  return (
    <a 
      href={href}
      target="_blank"
      rel="noreferrer"
      ref={ref}
      onClick={clickHandler}
      className={fullClassname}
      aria-labelledby={labelledby}
    >
      <span id={labelledby} className="translate-y-[1px] block">{children}</span>
    </a>
  );

});

export default DeepDiveOpenButton;
